import { render } from "./TableRowComponent.vue?vue&type=template&id=71c65464&scoped=true"
import script from "./TableRowComponent.vue?vue&type=script&lang=js"
export * from "./TableRowComponent.vue?vue&type=script&lang=js"

import "./TableRowComponent.vue?vue&type=style&index=0&id=71c65464&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c65464"]])

export default __exports__